module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Cut_16"],"path":[{"$":{"d":"M16,5.55s-1.26-1.16-4.26-.13L6.55,7.21l-.9-.31A2.58,2.58,0,0,0,7,4.75C7,3.23,5.43,2,3.5,2S0,3.23,0,4.75c0,1.2.87,2.08,2.34,2.58L4.26,8l-1.92.67C.87,9.17,0,10.05,0,11.25,0,12.77,1.57,14,3.5,14S7,12.77,7,11.25A2.58,2.58,0,0,0,5.66,9.1l.9-.31,5.18,1.79c3,1,4.26-.13,4.26-.13L8.87,8ZM1.5,4.75c0-.59.82-1.25,2-1.25s2,.66,2,1.25S4.68,6,3.5,6,1.5,5.34,1.5,4.75Zm2,7.75c-1.18,0-2-.66-2-1.25S2.32,10,3.5,10s2,.66,2,1.25S4.68,12.5,3.5,12.5Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Cut_16.svg
// module id = E+iH
// module chunks = 1